/* eslint-disable import/order */
import React from 'react';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskRovoServiceAgentRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskRovoServiceAgentRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { Redirect, type RouteContext } from '@atlassian/react-resource-router';
import { LazyProjectSettingsServiceDeskRovoServiceAgent } from './ui/service-desk-rovo-service-agent/ServicedeskRovoServiceAgentComponent.tsx';

const RovoServiceAgentRedirect = ({ match }: RouteContext): React.JSX.Element => (
	<Redirect to={`/jira/servicedesk/projects/${String(match.params.projectKey)}/settings/rovo`} />
);

export const projectSettingsServicedeskRovoServiceAgentRouteEntry: ReturnType<typeof createEntry> =
	createEntry(projectSettingsServicedeskRovoServiceAgentRoute, () => ({
		group: 'project-settings-servicedesk',
		ufoName: 'jsm-rovo-service-agent-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: RovoServiceAgentRedirect,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskRovoServiceAgent],
		perfMetricKey: 'jsm-rovo-service-agent-settings',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}));
